import { Navigate, Outlet } from 'react-router-dom';
import { useAppSelector } from '@/app/hooks';
import { ROUTES } from '@/app/routes';
import { selectIsAuthenticated, selectSessionChecked } from '@/slices/auth';
import { LoadingOverlay } from '@/components/feedback';

// Keeps an already-authenticated user off the login screen.
export const PublicOnlyRoute = () => {
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const sessionChecked = useAppSelector(selectSessionChecked);

  if (!sessionChecked) {
    return <LoadingOverlay fullscreen />;
  }
  if (isAuthenticated) {
    return <Navigate to={ROUTES.home} replace />;
  }
  return <Outlet />;
};
